import React, { PureComponent } from 'react';

import withSlide from '~/kits/general/scripts/components/withSlide';
import ComparisonMap from '~/kits/general/scripts/components/ComparisonMap';
import { getColorScale } from '~/kits/general/scripts/components/ComparisonMap/utils';
import { getMapDataByKey, getDonutDataByKey } from '~/kits/general/scripts/data-utils';

const colorScale = getColorScale([
  [0, '#ff978a'],
  [11, '#f78377'],
  [21, '#ee6f64'],
  [32, '#e55952'],
  [43, '#db4240']
]);


const mapData = getMapDataByKey('soc');
const donutData = getDonutDataByKey('soc', '#DB4240');
const maxLegendValue = 36;

class SocialistsMap extends PureComponent {
  render() {
    const { title, text, isActive } = this.props;

    return (
      <ComparisonMap
        title={title}
        text={text}
        isActive={isActive}
        mapData={mapData}
        colorScale={colorScale}
        donutData={donutData}
        maxLegendValue={maxLegendValue}
      />
    );
  }
}

export default withSlide(SocialistsMap);
